import o from "js-cookie";
import { useEffect as n } from "react";
import { StorageKey as c } from "./index50.mjs";
import { useStorage as S } from "./index51.mjs";
import { CookiesEnum as r } from "./index49.mjs";
const m = (e) => {
  const t = o.get(r.PublicUserId);
  return `${c.SessionStorePrefix}${t ?? "shared"}:${e}`;
}, f = (e) => o.get(r.BrowserSessionActiveId) === e.toString(), I = (e, t) => {
  n(() => {
    e && o.set(r.PublicUserId, [e, t].filter(Boolean).join("_"), {
      path: "/",
      secure: !0,
      sameSite: "strict"
    });
  }, [e, t]);
}, P = (e, t = {}) => {
  const s = o.get(r.PublicUserId) ?? "shared", i = S(m(e), t);
  return n(() => {
    f(s) || (i.removeByPrefix(c.SessionStorePrefix), o.set(r.BrowserSessionActiveId, s.toString(), {
      sameSite: "strict",
      path: "/"
    }));
  }, [s, i.removeByPrefix]), i;
};
export {
  m as getSessionStoreKey,
  I as useExtendSessionId,
  P as useSessionStore
};
